import { useRef, useState } from "react"
import JWTApi from "../../libs/login/JWTApi"
import {useSnackbar} from "../Snackbar/SnackbarProvider"
import Tabs from "../Tabs/Tabs"
import Form, { useForm } from "../Form/Form"
import Button from "../Button/Button"
import LoginForm, { ILoginForm } from "./LoginForm"
import SignupForm, { ISignupForm } from "./SignupForm"
import { useOverlay } from "../Overlay/OverlayProvider"
import usePinDlg from "./PinDlg"

const DIALOG_ID = "loginDialog"
export interface TLoginDlgProps {
    api:JWTApi
    onLogin?:Function
}

const LOGIN_TABS = [{id:"login",text:"Login"}, {id:"signup",text:"Signup"}]
export function LoginDlg(props:TLoginDlgProps){
    const {api} = props
    const [tab,setTab] = useState<string>("login")
    const {addSnackbar} = useSnackbar()
    const [busy,setBusy] = useState<boolean>(false)
    const {dirty, valid, setDirty} = useForm()
    const loginForm = useRef<ILoginForm|null>(null)
    const signupForm = useRef<ISignupForm|null>(null)
    const {popOverlay} = useOverlay()
    const {sendPin} = usePinDlg()

    const email = () => tab=="login" ? loginForm.current!.email : signupForm.current!.email
    const onLogin = async () => {
        if (!dirty) setDirty(true)

        if (!valid || busy) return
        else setBusy(true)

        try {
            if (tab=="login") await api.login(email(), loginForm.current!.password)
            else await api.register(email(), signupForm.current!.password, signupForm.current!.name)
            popOverlay(DIALOG_ID)
            props.onLogin?.()
        }catch(e){
            setBusy(false)
            addSnackbar(e)
        }
    }
    const onForgot = () => sendPin(api, email(), () => popOverlay(DIALOG_ID))
    return <>
        <div className="title">
            <Tabs options={LOGIN_TABS} onTab={tab => setTab(tab)} defaultValue="login"/>
        </div>
        <div className="content" key={tab}>
            {tab=="login" ? <LoginForm ref={loginForm} onSubmit={onLogin} onForgot={onForgot}/> : <SignupForm ref={signupForm} onSubmit={onLogin}/>}
        </div>
        <div className="actions">
            <Button onClick={_ => popOverlay(DIALOG_ID)}>Cancel</Button>
            <Button variant="contained" onClick={onLogin} disabled={busy || !valid}>{tab=="login" ? "Login" : "Create"}</Button>
        </div>
    </>
}

export default function useLoginDlg(){
    const {addOverlay,popOverlay,hasOverlay} = useOverlay()
    const showLogin = (api:JWTApi, modal:boolean, onLogin?:Function) => {
        if (hasOverlay(DIALOG_ID)) return
        else addOverlay(DIALOG_ID, {children:<Form><LoginDlg api={api} onLogin={onLogin}/></Form>, className:"dialog login", modal})
    }
    const hideLogin = () => popOverlay(DIALOG_ID)
    return {showLogin,hideLogin}
}